import { Howl } from 'howler';

const successSound = new Howl(
  {
    src: ["storage/app/media/sounds/sprite2.mp3"],
    sprite: {
      yes1: [9000, 3030.204081632654]
    }
  });
const cardSound = new Howl(
  {
    src: ["storage/app/media/sounds/card.mp3"],
  });

function playSuccess() {
  successSound.play('yes1')
}

export { successSound, cardSound, playSuccess }